import { internal } from '../../../vendor/elix.js';

const selectionController = Symbol('selection controller');
class SelectionController {
  static getController(element) {
    const root = element.getRootNode({ composed: true });
    let controller = root[selectionController];
    if (controller === undefined) {
      controller = new SelectionController(root);
      root[selectionController] = controller;
    }
    return controller;
  }

  constructor() {
    this.sets = {};
  }

  getSet(name) {
    if (!this.sets[name]) {
      this.sets[name] = {
        elements: [],
        initialized: false
      };
    }
    return this.sets[name];
  }

  isRequiredSet(name) {
    return this.getSet(name).elements.some(t => t.hasAttribute('required'));
  }

  register(element) {
    const set = this.getSet(element.name);
    set.elements.push(element);
  }

  unregister(element) {
    const set = this.getSet(element.name);
    set.elements.splice(set.elements.indexOf(element), 1);
  }

  initialize(name) {
    const set = this.getSet(name);
    if (set.initialized) {
      return;
    }
    const element = this.getSet(name).elements.find(t => t.checked);
    if (element) {
      set.elements.forEach(e => {
        e[internal.nativeInternals] && e[internal.nativeInternals].setValidity({});
        if (e.checked) {
          e[internal.nativeInternals] && e[internal.nativeInternals].setFormValue(e.value);
        }
      });
    } else {
      const first = this.getSet(name).elements[0];
      this.isRequiredSet(name) && first[internal.nativeInternals] && first[internal.nativeInternals].setValidity({valueMissing: true}, 'Please select one of these options');
    }
    set.initialized = true;
  }

  update(element) {
    if (this.updating) {
      return;
    }
    this.updating = true;
    const setElements = this.getSet(element.name).elements;
    if (element.checked) {
      setElements.forEach(e => {
        e.checked = e === element;
        element[internal.nativeInternals] && e[internal.nativeInternals].setValidity({});
      });
    } else {
      this.isRequiredSet(element.name) && element[internal.nativeInternals] && element[internal.nativeInternals].setValidity({valueMissing: true}, 'Please select one of these options');
    }
    this.updating = false;
  }

  focusNext(currElement) {
    const setElements = this.getSet(currElement.name).elements;
    const i = setElements.indexOf(currElement);
    currElement[internal.ids].inner.blur();
    this.focusOn(setElements[i + 1] || setElements[0]);
  }

  focusPrevious(currElement) {
    const setElements = this.getSet(currElement.name).elements;
    const i = setElements.indexOf(currElement);
    currElement[internal.ids].inner.blur();
    this.focusOn(setElements[i - 1] || setElements[setElements.length - 1]);
  }

  focusOn(currElement) {
    currElement[internal.ids].inner.click();
    currElement[internal.ids].inner.focus();
  }
}

export default SelectionController;
